export const FETCH_FOOD_MOOD = {
  START: 'START_FETCH_FOOD_MOOD',
  COMPLETE: 'COMPLETE_FETCH_FOOD_MOOD',
  FAIL: 'FAIL_FETCH_FOOD_MOOD',
  CLEANUP: 'CLEANUP_FETCH_FOOD_MOOD',
}

export const UPDATE_FOOD_MOOD_SIMPLE_DETAILS = {
  START: 'START_UPDATE_FOOD_MOOD_SIMPLE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_FOOD_MOOD_SIMPLE_DETAILS',
  FAIL: 'FAIL_UPDATE_FOOD_MOOD_SIMPLE_DETAILS',
}

export const UPDATE_FOOD_MOOD_IMAGE_DETAILS = {
  START: 'START_UPDATE_FOOD_MOOD_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_FOOD_MOOD_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_FOOD_MOOD_IMAGE_DETAILS',
}

export const UPDATE_FOOD_MOOD_RELATIONS_DETAILS = {
  START: 'START_UPDATE_FOOD_MOOD_RELATIONS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_FOOD_MOOD_RELATIONS_DETAILS',
  FAIL: 'FAIL_UPDATE_FOOD_MOOD_RELATIONS_DETAILS',
}

export const SET_FOOD_MOOD_PAGE_TO_DIRTY = 'SET_FOOD_MOOD_PAGE_TO_DIRTY'
